// Module
var code = `{{#if (.sellMarketButtonOnSmallOE && ._userPreferredShowBuySellMarket) || 
      (.sellBidButtonOnSmallOE && ._userPreferredShowSellBidBuyAsk) || 
      (.addAskButtonOnSmallOE && ._userPreferredShowAddBidAsk) }}

    <div class="js-chart-buttons-container" {{^.oeSmall}}style="float:left;{{#~/reverseButtons}}margin-left:1px;{{/}}" {{/}}>
        {{#if .oeSmall && .reverseButtons}}
            {{#if .addAskButtonOnSmallOE && ._userPreferredShowAddBidAsk}}
                <terceraButton terceraButtonStyle="js-button-red"
                               text="{{.addAskText}}"
                               on-btnClick="add_Ask"
                               enabled="{{.tradingLimitAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingLimitAllowed && .tradingLimitAllowedReason ? .tradingLimitAllowedReason : ''}}" />
            {{/if}}

            {{#if .sellBidButtonOnSmallOE && ._userPreferredShowSellBidBuyAsk}}
                <terceraButton terceraButtonStyle="js-button-red"
                               text="{{.sellBidText}}"
                               on-btnClick="sell_Bid"
                               enabled="{{.tradingLimitAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingLimitAllowed && .tradingLimitAllowedReason ? .tradingLimitAllowedReason : ''}}" />
            {{/if}}

            {{#if .sellMarketButtonOnSmallOE && ._userPreferredShowBuySellMarket}}
                <terceraButton terceraButtonStyle="js-button-red"
                               text="{{.sellMarketText}}"
                               on-btnClick="sell_market"
                               enabled="{{.tradingMarketAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingMarketAllowed && .tradingMarketAllowedReason ? .tradingMarketAllowedReason : ''}}" />
            {{/if}}
        {{else}}
            {{#if .sellMarketButtonOnSmallOE && ._userPreferredShowBuySellMarket}}
                <terceraButton terceraButtonStyle="js-button-red"
                               text="{{.sellMarketText}}"
                               on-btnClick="sell_market"
                               enabled="{{.tradingMarketAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingMarketAllowed && .tradingMarketAllowedReason ? .tradingMarketAllowedReason : ''}}" />
            {{/if}}

            {{#if .sellBidButtonOnSmallOE && ._userPreferredShowSellBidBuyAsk}}
                <terceraButton terceraButtonStyle="js-button-red"
                               text="{{.sellBidText}}"
                               on-btnClick="sell_Bid"
                               enabled="{{.tradingLimitAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingLimitAllowed && .tradingLimitAllowedReason ? .tradingLimitAllowedReason : ''}}" />
            {{/if}}

            {{#if .addAskButtonOnSmallOE && ._userPreferredShowAddBidAsk}}
                <terceraButton terceraButtonStyle="js-button-red"
                               text="{{.addAskText}}"
                               on-btnClick="add_Ask"
                               enabled="{{.tradingLimitAllowed}}"
                               isRelative="true"
                               tooltip="{{!.tradingLimitAllowed && .tradingLimitAllowedReason ? .tradingLimitAllowedReason : ''}}" />
            {{/if}}
        {{/if}}
    </div>
{{/if}}`;
// Exports
export default code;